import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertsComponent } from 'app/components/alerts/alerts.component';
declare const swal: any;

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(private dialog: MatDialog) { }

  public showLoading(message?: string){
    console.log('show loading')
    const dialogRef = this.dialog.open(AlertsComponent, {
      data: {
        disableClose: false,
        message: message
      }
    });
    return dialogRef
  }

  public stopLoading(ref:MatDialogRef<AlertsComponent>){
    ref.close();
  }
}
